/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class TypeVitalSignRequest extends MainRequest{

    static addTypeVitalSign(data) {
        return this.postSEC(ServicePath.TYPE_VITAL_SIGN_ADD, data);
    }

    static listAllTypeVitalSign() {
        return this.getSEC(ServicePath.TYPE_VITAL_SIGN_LIST_ALL);
    }

    static updateTypeVitalSign(data) {
        return this.postSEC(ServicePath.TYPE_VITAL_SIGN_UPDATE, data);
    }

    static deleteTypeVitalSign(data) {
        return this.postSEC(ServicePath.TYPE_VITAL_SIGN_DELE, data)
    }
    
}